import { combineReducers } from 'redux'
import location from './location'

import user from '../modules/user'
import profile from '../modules/profile'
import myContent from '../modules/userContent'
import routerLocations from '../modules/routerLocations'
import mods from '../modules/mods'
import browser from '../modules/browser'
import card from '../modules/card'
import entities from '../modules/entities'
import dimScreen from '../modules/dimScreen'
import pick from '../modules/pick'
import tags from '../modules/tags'
import search from '../modules/search'
import referrer from '../modules/referrer'
import ui from '../modules/ui'
import pickMode from '../modules/pickMode'
import readSettings from '../modules/readSettings'
import videoTiming from '../modules/videoTiming'
import viewSettings from '../modules/viewSettings'
import audioTiming from '../modules/audioTiming'
import errors from '../modules/errors'
import image from '../modules/image'
import sessionImages from '../modules/sessionImages'

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    location,
    user,
    profile,
    myContent,
    routerLocations,
    mods,
    browser,
    card,
    entities,
    dimScreen,
    pick,
    search,
    tags,
    referrer,
    ui,
    pickMode,
    readSettings,
    videoTiming,
    viewSettings,
    audioTiming,
    errors,
    image,
    sessionImages,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
